import type { VariantDef, VariantId } from '../types';
import { classic } from './classic';
import { challenge, powerplay, straightdown, streak, triple } from './official';
import { generala, kismet, maxiyatzy, yacht, yatzy } from './regional';
import { word } from './word';

export const VARIANTS: readonly VariantDef[] = [
  classic,
  triple,
  challenge,
  kismet,
  word,
  yatzy,
  maxiyatzy,
  yacht,
  generala,
  streak,
  straightdown,
  powerplay,
];

const byId = new Map<VariantId, VariantDef>(VARIANTS.map(v => [v.id, v]));

export function getVariant(id: VariantId): VariantDef {
  const v = byId.get(id);
  if (!v) throw new Error(`Unknown variant: ${id}`);
  return v;
}

export function isVariantId(id: string): id is VariantId {
  return byId.has(id as VariantId);
}

export const VARIANT_IDS = VARIANTS.map(v => v.id);
